<template>
    <div>
        <div :class="['uik-avatar-upload__wrapper']" @click="$emit('upload')">
            <div class="uik-avatar-upload__progress" :style="'height:' + progress + 'px'"></div>
            <slot name="avatar"></slot>
            <div class="uik-avatar-upload__button-overlay" :class="{ visible: imageUrl == '' ? true:false }">
                <div>
                    <Uikon icon="camera" />
                    <span>{{ text }}</span>
                </div>
            </div>
        </div>
        <div class="ui-avatar-upload__upload">
            <slot name="upload"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "UikAvatarUpload",
    props: {
        imageUrl: { type: String, default: "" },
        text: { type: String, default: "" },
        progress: { type: Number, default: 0 }
    }
}
</script>

<style lang="scss">
.uik-avatar-upload__wrapper {
    display: inline-block;
    position: relative;
    border-radius: 50%;
    border: none;
    background: transparent;
    outline: none;
    cursor: pointer;
    overflow: hidden;
    &:hover {
        .uik-avatar-upload__button-overlay {
            opacity: 1;
            .uikon {
                font-size: 20px;
            }
        }
    }
    .uik-avatar-upload__button {
        background: rgba(0, 0, 0, 0.35);
        transition: opacity 0.15s;
        .uikon {
            color: white;
            font-weight: 100;
            font-size: 26px;
            transition: font-size 0.15s;
        }
        span {
            color: white;
            font-size: 12px;
            margin-top: 5px;
            font-weight: 500;
        }
    }
    .uik-avatar-upload__button-overlay {
      position: absolute;
      top:0;
      left:0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      background: rgba(0, 0, 0, 0.35);
      transition: opacity 0.15s;
      opacity: 0;
      &.visible,
      &:hover {
        opacity: 1;
      }
      & > div {
        z-index: 5;
      }
      .uikon {
          color: white;
          font-weight: 100;
          font-size: 26px;
          line-height: 22px;
          transition: font-size 0.15s;
      }
      span {
          color: white;
          font-size: 12px;
          margin-top: 5px;
          font-weight: 500;
      }
    }
}
.uik-avatar-upload__progress {
    display: block;
    position: absolute;
    width: 100%;
    height: 0;
    background: $primary;
    z-index: 1;
    bottom: 0;
    transition: height 150ms ease-out;
}
</style>
